import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "record",
  "use": "record-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"record\"><g clip-path=\"url(#record_clip0_835_29)\"><path d=\"M8 10a2 2 0 100-4 2 2 0 000 4z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8A8 8 0 110 8a8 8 0 0116 0zm-1 0A7 7 0 111 8a7 7 0 0114 0z\" /></g><defs><clipPath id=\"record_clip0_835_29\"><path d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol